module.exports = __webpack_public_path__ + "img/live_detail_icon2.8d92415e.png";